export default "__VITE_ASSET__uKBY1HSt__"